export const KRAKEN_SUPPORT_EMAIL = 'generationflex-support@kraken.tech';
